import React from 'react';
import PropTypes from 'prop-types';
import { useTabsNavigationStore, SHIFT_SECTIONS } from '../../../stores';
import SettingsContent from './shift/SettingsContent';
import BroadcastContent from './broadcast/BroadcastContent';
import TeamsContent from './teams/TeamsContent';
import EventsContent from './events/EventsContent';
import GamesContent from './games/GamesContent';

// Диспетчер контента раздела смены по selectedSection.
export default function ShiftContent({ shift, refetchShifts }) {
    const selectedSection = useTabsNavigationStore(state => state.selectedSection);

    switch (selectedSection) {
        case SHIFT_SECTIONS.SETTINGS:
            return <SettingsContent shift={shift} refetchShifts={refetchShifts} />;
        case SHIFT_SECTIONS.TEAMS:
            return <TeamsContent shift={shift} />;
        case SHIFT_SECTIONS.EVENTS:
            return <EventsContent shift={shift} />;
        case SHIFT_SECTIONS.GAMES:
            return <GamesContent shift={shift} />;
        case SHIFT_SECTIONS.BROADCAST:
            return <BroadcastContent shift={shift} />;
        default:
            return <div className="set-card">Выберите раздел</div>;
    }
}

ShiftContent.propTypes = {
    shift: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired,
    refetchShifts: PropTypes.func.isRequired
};
